import React from 'react';
import { Box, Typography, IconButton, Skeleton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

interface AttachedFile {
    file: File;
    renamedName: string;
}

interface Props {
    attachedFiles: AttachedFile[];
    isSubmitting: boolean;
    removeFile: (index: number) => void;
    setPreviewFile: (file: { url: string, type: string }) => void;
}

const AttachedFilesPreview: React.FC<Props> = ({ attachedFiles, isSubmitting, removeFile, setPreviewFile }) => (
    <Box display="flex" flexDirection="column" gap={1} mt={1} width="100%" sx={{ overflowY: 'auto', maxHeight: '120px' }}>
        {isSubmitting ? (
            [...Array(2)].map((_, i) => (
                <Skeleton key={i} variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
            ))
        ) : (
            attachedFiles.map((attached, index) => (
                <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        bgcolor: "#F3F4F6",
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        width: "100%",
                    }}
                >
                    {attached.file.type.startsWith("audio") ? (
                        <audio controls style={{ width: '100%' }} src={URL.createObjectURL(attached.file)} />
                    ) : (
                        <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1, mr: 2 }}>
                            {attached.renamedName}
                        </Typography>
                    )}
                    <Box display="flex" alignItems="center" gap={1}>
                        {(attached.file.type.startsWith("image/") || attached.file.type === 'application/pdf') && (
                            <IconButton
                                onClick={() => setPreviewFile({ url: URL.createObjectURL(attached.file), type: attached.file.type })}
                                size="small"
                                title="Previsualizar archivo"
                            >
                                <VisibilityIcon fontSize="small" sx={{ color: '#4B5563' }} />
                            </IconButton>
                        )}
                        <IconButton onClick={() => removeFile(index)} size="small" title="Eliminar">
                            <DeleteIcon sx={{ color: '#EF4444' }} />
                        </IconButton>
                    </Box>
                </Box>
            ))
        )}
    </Box>
);

export default AttachedFilesPreview;
